import { useEffect } from 'preact/hooks';
import { Maximize, Smartphone } from 'lucide-preact';
import { canFullscreen, enterFullscreen } from '../fullscreen';
import { isNativeApp } from '../platform';
import { track } from '../state/telemetry';

/** Same condition as the stylesheet rule that shows the overlay (ui.css). */
const PORTRAIT_PHONE = '(orientation: portrait) and (max-width: 600px) and (pointer: coarse)';

/**
 * The game is landscape-only. Phone browsers held upright get this screen instead (ui.css shows it
 * only for portrait phones); Android can jump straight to fullscreen landscape from here. The native
 * shells lock landscape themselves.
 */
export function RotateOverlay() {
  // Logged once per app run when shown (how many phone players hold it upright).
  useEffect(() => {
    if (isNativeApp) return;
    const m = matchMedia(PORTRAIT_PHONE);
    let sent = false;
    const check = (): void => {
      if (m.matches && !sent) {
        sent = true;
        track('rotate_prompt', { label: 'shown' });
      }
    };
    check();
    m.addEventListener('change', check);
    return () => m.removeEventListener('change', check);
  }, []);
  if (isNativeApp) return null;
  return (
    <div class="rotate-overlay" role="dialog" aria-label="Turn your phone sideways">
      <div class="rotate-phone" aria-hidden="true">
        <Smartphone size={76} strokeWidth={1.5} />
      </div>
      <h2>Turn your phone sideways</h2>
      <p>Voxel Marines is played in landscape.</p>
      {canFullscreen() && (
        <button class="btn primary big" onClick={() => void enterFullscreen()}>
          <Maximize size={22} /> Play full screen
        </button>
      )}
    </div>
  );
}
